/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        toast: {
            borderRadius: {
                value: "2px",
                type: "dimension",
            },
            borderLeftWidth: {
                value: "6px",
            },
            borderRightWidth: {
                value: "0",
                type: "dimension",
            },
            borderVerticalWidth: {
                value: "0",
                type: "dimension",
            },
            boxShadow: {
                value: {
                    layers: [
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "4px",
                            blur: "24px",
                            spread: "-8px",
                            color: "#00000010",
                        },
                        {
                            inset: false,
                            offsetX: "0px",
                            offsetY: "1px",
                            blur: "6px",
                            spread: "-2px",
                            color: "#00000038",
                        },
                    ],
                    stringValue: "0px 4px 24px -8px #00000010, 0px 1px 6px -2px #00000038",
                },
                type: "shadow",
            },
            width: {
                value: "340px",
                type: "dimension",
            },
            divided: {
                paddingLeft: {
                    value: "16px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "8px",
                    type: "dimension",
                },
                message: {
                    paddingRight: {
                        value: "16px",
                        type: "dimension",
                    },
                    paddingBottom: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                actions: {
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                    borderTopColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    borderTopWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
